<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<template-layout *ngIf="layout === 'template'"></template-layout>
<manager-layout *ngIf="layout === 'manager'"></manager-layout>
<modern-layout *ngIf="layout === 'modern'"></modern-layout>